import { NgModule } from '@angular/core';

import { AdminReportsModule } from './admin-reports/admin-reports.module';

@NgModule({
  exports: [
    AdminReportsModule
  ],
  imports: [
    AdminReportsModule
  ]
})
export class ReportsModule {}
